import { 
  FETCH_SOCIAL_INFO,
  FETCH_SOCIAL_INFO_SUCCESS,
  FETCH_SOCIAL_INFO_FAILED,
} from "../actions/types";

export const INITIAL_STATE = {
  infos:null,
  loading: false,
  error:{
    flag:false,
    msg: null
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SOCIAL_INFO:
      return {
        ...state,
        loading:true
      };
    case FETCH_SOCIAL_INFO_SUCCESS:
      return {
        ...state,
        infos:action.payload,
        loading:false
      };
    case FETCH_SOCIAL_INFO_FAILED:
      return {
        ...state,
        infos:{},
        loading:false,
        error:{
          flag:true,
          msg:action.payload
        }
      };
    default:
      return state;
  }
};